import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import OrderGrid from './ordergrid.model';

@Component({
  selector: 'lm-ordergrid',
  templateUrl: './ordergrid.component.html',
  styleUrls: ['./ordergrid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderGridComponent implements OnInit {
  @Input() item: any;
  @Input() type: number = 1;
  @Input() status: number = 1;
  @Input() disabled: boolean = false;
  @Input() check: boolean = false;
  @Input() noaction: boolean = false;
  @Input() nostatus: boolean = false;
  @Input() alert: boolean = false;
  @Input() t: any = null;
  @Input() idChecked: string[] = [];

  @Output() onClickEvent = new EventEmitter<OrderGrid>();
  @Output() onSelectedEvent = new EventEmitter<string>();
  @Output() onOptionEvent = new EventEmitter<string>();
  @Output() onOptionNoStockEvent = new EventEmitter<string>();
  @Output() onOptionReportEvent = new EventEmitter<string>();

  ngOnInit(): void {}
}
